{
  "defaultTitle": "تعذر تسجيل الوصول",
  "defaultMessage": "يرجى تأكيد المعلومات مع المرسل أو التواصل مع المستودع",
  "backToHomescreen": "العودة إلى الشاشة الرئيسية",
  "hideErrorLog": "إخفاء سجل الأخطاء",
  "viewErrorLog": "عرض سجل الأخطاء",
  "errorLogMessageLabel": "الرسالة:",
  "errorLogStatusLabel": "رمز الحالة:",
  "unknown": "غير معروف"
}
